import { STATUS_DICTIONARY } from '../constants/status-dictionary.constant';

export const disableSelect = (status) => (status === STATUS_DICTIONARY.close ? true : false);
